import { render, staticRenderFns } from "./ConcernedInfoCard.vue?vue&type=template&id=48b593e5&scoped=true&"
import script from "./ConcernedInfoCard.vue?vue&type=script&lang=js&"
export * from "./ConcernedInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b593e5",
  null
  
)

export default component.exports